export enum DefaultValuePercent {
  ZERO = "0%",
  MINUS_SIGN = "-",
  EMPTY = "",
}
